import CategoriesModuleModel from 'src/model/modules/categories.model';

const moduleSel = (state: any): CategoriesModuleModel => state.categories;

/* Pending states */
export const categoriesPendingSel = (state: any) =>
  moduleSel(state).getCategoriesIsPending;
export const subcategoriesPendingSel = (state: any) =>
  moduleSel(state).getSubcategoriesPending;
export const subcategoriesFiltersPendingSel = (state: any) =>
  moduleSel(state).getSubcategoriesFilterIsPending;
export const productsPendingSel = (state: any) =>
  moduleSel(state).getProductsIsPending;

/* Values states */
export const categoriesSel = (state: any) => moduleSel(state).categories;
export const productsSel = (state: any) => moduleSel(state).products;
export const filtersSel = (state: any) => moduleSel(state).filters;
export const activeSubcategoryIDSel = (state: any) =>
  moduleSel(state).activeSubcategory.id;
export const activeSubcategoryNameSel = (state: any) =>
  moduleSel(state).activeSubcategory.name;
export const activeFiltersSel = (state: any) => moduleSel(state).activeFilters;
export const subcategoriesSel = (state: any) => moduleSel(state).subcategories;
export const filteredProductsSel = (state: any) =>
  moduleSel(state).filteredProducts;

/* Error manager */
export const errorSel = (state: any) => moduleSel(state).error;
export const failedSel = (state: any) => moduleSel(state).error.hasFailed;
